module.exports = __webpack_public_path__ + "img/timer.7a4f3cae.svg";